import {http} from '../utils'
// 查询
const searchAction = (params) => {
  const url = `/market/management/shortLink/page`
  return http.post(url, params)
}
// 获取status列表
const getStatus = (type) => {
  const url = `/market/common/codeList/${type}`
  return http.post(url)
}
// 获取group列表
const getGroup = (params) => {
  const url = '/market/management/group/all'
  return http.post(url, params)
}
// 获取 详情
const getAction = (id) => {
  const url = `/market/management/shortLink/detail/${id}`
  return http.post(url)
}
// 新建
const addAction = (params) => {
  const url = `/market/management/shortLink/save`
  return http.post(url, params)
}
// 删除
const deleteAction = (id) => {
  const url = `/market/management/shortLink/delete/${id}`
  return http.post(url)
}
// 同步
const syncAction = () => {
  const url = '/market/management/shortLink/sync'
  return http.post(url)
}
// 获取剩余短链数
const remainingNumberAction = () => {
  const url = '/market/management/shortLink/remainingNumber'
  return http.post(url)
}

export default {
  searchAction,
  getStatus,
  getGroup,
  getAction,
  addAction,
  deleteAction,
  syncAction,
  remainingNumberAction
}
